import React from 'react'
import { useLocation } from 'react-router-dom'
import { ROUTES } from '../constants/Routing'

const useLogo = props => {
  const { fontSize, blackMode, height } = props || {}
  const location = useLocation()
  const { pathname } = location || {}
  const adminMode = pathname.includes(ROUTES.ADMIN_ROOT)
  const adminLogin = pathname.includes(ROUTES.ADMIN_LOGIN)

  const logo = {
    lndata: <div style={{ fontSize }}>Ln {'\u007B'} 360&deg; {'\u007d'}</div>,
    admin: <img src={blackMode ? '/LogoBlack.png' : '/Logo.png'} alt="" />,
    cht: <img src={'/CHT.png'} alt='' style={{ height: height || '36px' }} />
  }

  return logo[process.env.REACT_APP_LOGO] || (adminMode && !adminLogin ? logo.admin : logo.lndata)
}

export default useLogo
